export default "PCAE 2026 — Plan de Compétitivité agricole (FEADER) | Solution Éco France";
